// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_93444fe79c--tooltip--iKIv0","arrow_tooltip":"_93444fe79c--arrow_tooltip--FnHui","arrow":"_93444fe79c--arrow--M3H38"};